<template>
  <div v-if="(farPayCallBackResponse && farPayCallBackResponse === 'failure') || saveTransactionStatus === 404">
    <Header />
    <b-row>
      <b-col
        md="6"
        lg="4"
        offset-lg="4"
        offset-md="3"
      >
        <b-card
          class="text-center"
          footer-class="text-muted"
        >
          <div class="mb-1">{{ 'There has occured a problem in your payment/card details. Please try again.' }}</div>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="retryFarPay()"
          >
            {{ 'Try Again' }}
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
  <div v-else-if="(!planCompleted && !tokenExpired) && !landSuccessPage && (!farPayCallBackResponse || farPayCallBackResponse && initialPlanType !== 1)">
    <Header />
    <div class="container">
      <b-row>
        <b-col
          md="6"
          lg="4"
          offset-lg="4"
          offset-md="3"
          xs="12"
        >
          <b-card
            :title="$t('DEBTIA_CASE_ID') + ': ' + debtiaCaseId"
            class="text-center"
            footer-class="text-muted"
          >
            <div id="my-container">
              <!-- Our triggering (target) element -->
              <b-button
                id="popover-reactive-1"
                ref="button"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
              >
                <!-- {{ $t('DEBTIA_PENDING_DEBT_TEXT') }} : {{ new Intl.NumberFormat('de-DE').format(remainingAmount) }} kr. -->
                {{ $t('DEBTIA_PENDING_DEBT_TEXT') }} : {{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(remainingAmount).toFixed(2)) }}
              </b-button>

              <!-- Our popover title and content render container -->
              <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
              <!-- We specify the same container as the trigger button, so that popover is close to button -->
              <b-popover
                ref="popover"
                target="popover-reactive-1"
                triggers="hover"
                placement="auto"
                container="my-container"
              >
                <template #title>
                  <div class="d-flex justify-content-between align-items-center">
                    <span>{{ $t('DEBTIA_BEHALF_CLAIM_TEXT') }} {{ creditor }}</span>
                  </div>
                </template>
                <table style="width:100%">
                  <tr
                    v-for="amount in debtBreakItems"
                    :key="amount.taskname"
                    class="business-item"
                  >
                    <td>{{ amount.jobTaskName }}</td>
                    <td class="right-values">
                      <!-- {{ amount.scheduleTotalPrice }} Kr -->
                      {{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount.scheduleTotalPrice).toFixed(2)) }}
                    </td>
                  </tr>
                </table>
              </b-popover>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="spinnerstay"
      id="spinner-div"
    >
      <b-spinner
        key="success"
        variant="success"
        class="mr-1 custom-spinner-style"
        type="grow"
      />
    </div>
    <div class="container">
      <b-row>
        <b-col
          sm="10"
          offset-sm="1"
        >
          <Plansteps
            ref="plansteps"
            :is-amount-based-plan="isAmountBasedPlan"
            :is-period-based-plan="isPeriodBasedPlan"
            :min-amount="minAmount"
            :max-months="maxMonths"
            :remaining-amount="remainingAmount"
            :plan-payment-method="planPaymentMethod"
            :plan-response="planResponse"
            :default-currency="defaultCurrency"
            :full-api-response="fullApiResponse"
            @planCompleted="planFunction($event)"
            @spintoggle="spinToggleFunction($event)"
          />
        </b-col>
      </b-row>
    </div>
  </div>
  <div v-else-if="tokenExpired && !landSuccessPage && !farPayCallBackResponse">
    <Header />
    <b-row>
      <b-col
        md="6"
        lg="4"
        offset-lg="4"
        offset-md="3"
      >
        <b-card
          class="text-center"
          footer-class="text-muted"
        >
          {{ $t('TOKEN_EXPIRED_MSG') }}
        </b-card>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <Header />
    <div
      v-if="paymentmethodResponse !== 1 && spinnerstay"
      id="spinner-div"
    >
      <b-spinner
        key="success"
        variant="success"
        class="mr-1 custom-spinner-style"
        type="grow"
      />
    </div>
    <b-row v-if="paymentmethodResponse !== 1">
      <b-col
        md="6"
        lg="4"
        offset-lg="4"
        offset-md="3"
      >
        <b-card class="text-center">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-1
            variant="outline-primary"
          >
            {{ $t('DEBTIA_INSTALLMENTPLAN_DECLARATIONPDF_BTN') }}
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="6"
        lg="6"
        offset-lg="3"
        offset-md="3"
      >
        <b-card
          v-if="paymentmethodResponse !== 1"
          no-body
          class="business-card"
        >
          <b-card-header class="pb-1">
            <b-card-title>J.nr. {{ caseID }}</b-card-title>
          </b-card-header>

          <b-card-body>
            <b-card-text>{{ $t('DEBTIA_INSTALLMENTPLAN_END_MSG') }}</b-card-text>
            <div class="business-items">
              <div class="d-flex align-items-center justify-content-between">
                <label class="col-md-3">
                  {{ $t('DEBTIA_PAYMENT_DATE') }}
                </label>
                <label class="col-md-3">
                  {{ $t('DEBTIA_PAID_AMOUNT') }}
                </label>
                <label class="col-md-3">
                  {{ $t('DEBTIA_INTEREST') }}
                </label>
                <label class="col-md-3">
                  {{ $t('DEBTIA_REST_AMOUNT') }}
                </label>
              </div>
              <div
                v-for="installment in installmentScheduler"
                :key="installment.isntallment_date"
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <span class="col-md-3">
                    {{ installment.installment_date }}
                  </span>
                  <span class="col-md-3">
                    <b-badge variant="light-success">
                      <!-- {{ new Intl.NumberFormat('de-DE').format(parseFloat(installment.installment_amount)) }} kr. -->
                      {{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(installment.installment_amount).toFixed(2)) }}
                    </b-badge></span>
                  <span class="col-md-3">
                    <b-badge variant="light-danger">
                      <!-- +{{ new Intl.NumberFormat('de-DE').format(parseFloat(installment.interest)) }} kr. interest -->
                      +{{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(installment.interest).toFixed(2)) }}
                    </b-badge></span>
                  <span class="col-md-3">
                    <b-badge variant="light-info">
                      <!-- {{ new Intl.NumberFormat('de-DE').format(parseFloat(installment.remaining_amount)) }} kr. -->
                      {{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(installment.remaining_amount).toFixed(2)) }}
                    </b-badge></span>
                </div>
              </div>
            </div>
            <div class="alert-div">
              <div class="alert-body">
                <feather-icon
                  icon="InfoIcon"
                  class="mr-50"
                />
                {{ $t('DEBTIA_INSTALLMENTPLAN_END_WARNING_MSG') }}
              </div>
            </div>
          </b-card-body>
        </b-card>
        <b-card
          v-else
          no-body
          class="business-card"
        >
          <b-card-header class="pb-1">
            <b-card-title>{{ caseID }}</b-card-title>
          </b-card-header>

          <b-card-body>
            <b-card-text>{{ $t('DEBTIA_INSTALLMENTPLAN_FULLPAYMENT_END_MSG') }} {{ new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(totalpaidamount).toFixed(2)) }}</b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-1"
      hide-footer
      hide-header
    >
      <iframe
        :src="pdfURL"
        width="100%"
        height="500px"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BCardHeader,
  BCard,
  BRow,
  BCol,
  BButton,
  BPopover,
  BCardTitle,
  BCardBody,
  BCardText,
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import axios from 'axios'
import axiosIns from '../libs/axios'
import Plansteps from './Debtoragreementplans/Plansteps.vue'
import Header from './Header.vue'
import constants from '../app-configs/constants'

export default {
  components: {
    BCardHeader,
    BCard,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardBody,
    BCardText,
    BBadge,
    Plansteps,
    BPopover,
    BSpinner,
    Header,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      creditor: 'Claim on the behalf of XYZ',
      company_slogan: 'company description will be added here',
      debtor_id: '',
      debtorName: '',
      remainingAmount: '',
      isPeriodBasedPlan: true,
      isAmountBasedPlan: true,
      minAmount: 0,
      maxMonths: 12,
      planPaymentMethod: 0,
      planResponse: {},
      planCompleted: false,
      amountItems: [],
      debtBreakItems: [],
      caseID: '',
      debtiaCaseId: '',
      pdfURL: '',
      totalpaidamount: 0,
      tokenExpired: '',
      spinnerstay: true,
      paymentmethodResponse: 0,
      installmentScheduler: [],
      serverBaseUrl: constants.serverBaseUrl,
      landSuccessPage: false,
      defaultCurrency: 'DKK',
      fullApiResponse: {},
      farPayCallBackResponse: null,
      saveTransactionStatus: 0,
      initialPlanType: 0,
    }
  },
  created() {
    // this.tokenExpired = true
    let token = window.location.href.split('/')
    token = token.pop()
    let urlToken = null
    if (token.includes('?')) {
      const fullResult = token.split('?')
      // eslint-disable-next-line prefer-destructuring
      urlToken = fullResult[0]
      // console.log('this payemnts methods ', this.paymentmethod)
      const result = fullResult.pop()
      this.farPayCallBackResponse = result.includes('success') ? 'success' : 'failure'
      this.saveTransaction(urlToken)
    } else {
      urlToken = token
    }
    axiosIns.get(`installment_plan/generate_agreement_form/${urlToken}`).then(response => {
      if (response.status) {
        this.fullApiResponse = response
        this.initialPlanType = this.fullApiResponse.data.plan_type
        this.debtiaCaseId = response.data.debtia_debt_case_id
        if (response.data.plan_status === 2) this.planCompleted = true
        if (response.data.plan_type === 1) {
          this.paymentmethodResponse = 1
        }
        if (response.data.plan_type > 1 && response.data.is_payment === 1) {
          this.$refs.plansteps.changeTab()
          this.$refs.plansteps.generatepdf(response.data.journal_id)
        }
        /*
        check if the plan_status is greater than 0 which means plan was succesfully created once
        default value is 0
        upon plan creation and payment authorization it is 1
        and after full payment it becomes 2
        */
        if (response.data.plan_status > 0 && response.data.signature) {
          if (response.data.plan_type === 1) {
            // plan is full payment because plan_type = 1 is of full payment
            this.totalpaidamount = response.data.remaining_amount
            this.caseID = response.data.debtia_debt_case_id
            this.paymentmethodResponse = 1
          } else if (response.data.signature) {
            // not full payment of course becase full payment doesn't require signature
            this.spinnerstay = true
            this.generatepdf()
          }
          this.landSuccessPage = true
        // }
        // if (response.data.plan_status === 1 && response.data.signature) {
        //   if (response.data.plan_type !== 1) {
        //     this.spinnerstay = true
        //     this.generatepdf()
        //   }
        //   this.landSuccessPage = true
        // } else if (response.data.plan_status > 0 && response.data.plan_type === 1) {
        //   this.totalpaidamount = response.data.amount
        //   this.caseID = response.data.debtia_debt_case_id
        //   this.paymentmethodResponse = 1
        //   this.landSuccessPage = true
        } else {
          axiosIns.get(`installment_plan/getcasedetails/${response.data.journal_id}`).then(debtorresponse => {
            this.creditor = debtorresponse.data.data.creditorName
            this.debtBreakItems = debtorresponse.data.data.alltasks
            this.defaultCurrency = debtorresponse.data.data.default_currency
            this.spinnerstay = false
          })
          this.planResponse = response.data
          this.caseID = response.data.debtia_debt_case_id
          this.debtor_id = response.data.debtor_id
          this.debtorName = response.data.debtor_name
          // this.remainingAmount = parseInt(response.data.remaining_amount, 10) / 100
          this.remainingAmount = response.data.remaining_amount
          this.isPeriodBasedPlan = response.data.period_based_plan
          this.isAmountBasedPlan = response.data.amount_based_plan
          this.minAmount = response.data.min_amount
          this.maxMonths = response.data.max_months
          this.planPaymentMethod = response.data.payment_method
          this.tokenExpired = false
          this.totalpaidamount = response.data.remaining_amount
        }
      }
    }).catch(error => {
      console.log(error)
      this.tokenExpired = true
    })
  },
  methods: {
    retryFarPay() {
      const farPayUrl = localStorage.getItem('farPayUrl')
      window.location.href = farPayUrl
    },
    spinToggleFunction(toggleval) {
      this.spinnerstay = toggleval
    },
    async saveTransaction(token) {
      await axiosIns.post('/farpay/order/save-transaction', {
        token,
        action: 'save_farpay_response',
        status: this.farPayCallBackResponse,
      }).then(() => {
        this.saveTransactionStatus = 200
      }).catch(() => {
        this.saveTransactionStatus = 404
      })
    },
    planFunction(result) {
      this.planCompleted = result.status
      this.paymentmethodResponse = result.paymentmethod
      this.caseID = result.caseInfo.caseID
      // this.pdfURL = this.serverBaseUrl + result.pdfURL
      this.pdfURL = this.serverBaseUrl + result.pdfURL
      this.installmentScheduler = result.installmentsData
      if (result.paymentmethod !== 1) {
        this.amountItems = result.caseInfo.alltasks
      } else {
        this.totalpaidamount = result.caseInfo.amountpaid
      }
    },
    async generatepdf() {
      const urlToken = this.$refs.plansteps.popToken()
      await axiosIns.post('installment_plan/generate_installmentplan_pdf', {
        action: 'generate_plan_pdf',
        token: urlToken,
      }).then(response => {
        this.pdfURL = this.serverBaseUrl + response.data.agreement_pdf_url
        this.caseID = response.data.caseInformation.caseID
        this.installmentScheduler = response.data.installments_data
        this.remainingAmount = parseFloat(response.data.plan_amount)
        this.defaultCurrency = response.data.default_currency
        this.spinnerstay = false
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';

  .custom {
    background: $primary;
  }
  .right-values{
    float: right;
  }
  @media only screen and (max-width: 767px){
    #spinner-div{
      height: 80%;
    }
  }
  @media only screen and (min-width: 767px){
    #spinner-div{
      height: 50%;
    }
  }
  #spinner-div{
    background-color: #f1efef;
    width: 100%;
    position: absolute;
    border-radius: 10px;
    z-index: 1;
    opacity: 0.7;
  }

  .custom-spinner-style{
    margin-left: 50%;
    margin-top: 10%;
  }
  .vue-form-wizard .wizard-nav-pills {
    display: flex;
    justify-content: center;
  }

  .btn-group.btn-group-lg{
    display: flex !important;
    justify-content: center;
  }

  .popover-body{
    padding: 12px 5px !important
  }

  .alert-div{
    padding: 10px;
    border: 1px solid #ff6e6e;
    border-radius: 6px;
    background-color: #ffe7e7;
    color: #ff5252;
  }

  @media only screen and (max-width: 767px){
    .btn-group-lg > .btn{
      font-size: 0.75rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
</style>
